export default __webpack_public_path__ + "static/media/sensemaking-in-the-dynamic.abec9e54.jpg";